import React, { useEffect, useState, useContext } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import axiosInstance from "../axios";
import { BusinessContext } from "../BusinessContext";
import { CircularProgress } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";

function PlatesContent() {
  const theme = useTheme();
  const themeColors = theme.palette.pointGenie;
  const [platesData, setPlatesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { selectedBusinessId } = useContext(BusinessContext);
  const [copied, setCopied] = useState(false);
  const {t}=useTranslation();
  const headerStyle = {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "500",
    color: themeColors.text,
    backgroundColor: themeColors.surfaceMuted,
    textAlign: "left",
  };

  const cellStyle = {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    color: themeColors.success,
    px: "14px",
    py: "8px",
  };
  const cellStyles = {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    color: themeColors.text,
    px: "14px",
    py: "8px",
  };

  const cellStyless = {
    fontFamily: "Nunito",
    fontSize: "14px",
    fontWeight: "500",
    color: themeColors.accentBlue,
    px: "14px",
    py: "8px",
  };

  useEffect(() => {
    const fetchPlates = async () => {
      if (!selectedBusinessId) {
        console.error("Business IDmissing!");
        setLoading(false); // Stop loading
        setPlatesData([]); // Set empty array
        return;
      }
      setLoading(true);
      try {
        const response = await axiosInstance.post(
          "places.php?method=business_plates",
          {
            business_id: selectedBusinessId,
          }
        );
        if (response.data?.plates) {
          setPlatesData(response.data?.plates);
        } else {
          console.error("No plates found in response");
          setPlatesData([]);
        }
      } catch (error) {
        console.error("Error fetching plates:", error);
        setPlatesData([]);
      }
      setLoading(false);
    };
    fetchPlates();
  }, [selectedBusinessId]);

  const handleCopy = (code) => {
    const currentUrl = window.location.origin;
    const url = `${currentUrl}/r/code=${code}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Box paddingLeft={"30px"} color={themeColors.text}>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center"  height= "90vh" p={3}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontSize:{xs:"24px",sm: "28px"},
              fontWeight: "600",
              lineHeight: "16px",
              color: themeColors.text,
              px: "14px",
              pb: "25px",
              pt: "14px",
            }}
          >
           {t("Genie Tags")}
          </Typography>

          <TableContainer
            component={Paper}
            sx={{
              maxWidth: { xs: "90%", sm: "60%" },
              mt: 2,
              backgroundColor: themeColors.card,
              border: `1px solid ${themeColors.border}`,
            }}
          >
            <Table sx={{width:{xs:"max-content",sm:"100%"}}}>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerStyle}>{t("Code")}</TableCell>
                  <TableCell sx={headerStyle}>{t("Status")}</TableCell>
                  <TableCell sx={headerStyle}>{t("Scans")}</TableCell>
                  <TableCell sx={headerStyle}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {platesData.length > 0 ? (
                  platesData.map((plate, index) => (
                    <TableRow key={index}>
                      <TableCell sx={cellStyles}>{plate.plate_code}</TableCell>
                      <TableCell sx={cellStyle}>Active</TableCell>
                      <TableCell sx={cellStyle}>{plate.scans}</TableCell>
                      <TableCell sx={{ ...cellStyless }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Box
                            sx={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              window.open(
                                `${window.location.origin}/r/code=${plate.plate_code}`,
                                "_blank"
                              )
                            }
                          >
                            {`${window.location.origin}/r/code=${plate.plate_code}`}
                          </Box>
                          <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
                            <ContentCopyIcon
                              sx={{
                                color: themeColors.text,
                                marginLeft: 1,
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation(); // prevent triggering text click
                                handleCopy(plate.plate_code);
                              }}
                            />
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={3}
                      sx={{ textAlign: "center", py: 2, fontWeight: 600 }}
                    >
                     {t("No Data Available")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
}

export default PlatesContent;
